module.exports = __webpack_public_path__ + "static/media/play-start.a5174d96.svg";